export default __webpack_public_path__ + "static/media/1.5cfdd8d3.webp";